// extracted by mini-css-extract-plugin
export default {"container":"_3u9PhyZ6iYjKtJyQlcaH8i","isSelected":"_31mKrvcmQN6mZ1KwIygnKs","image":"MYOKvX9ZB1t8Y9I88DFLb","content":"KlYveHj6Ksq_UK3akSXk7"};